// extracted by mini-css-extract-plugin
export var socialIcons = "SocialIcons-module--socialIcons--6nvK3";